import instanceQuery from 'graphql/queries/supplier/PurchasePaymentTransactionQuery.graphql';
import fragment from 'graphql/fragments/nominal/PostedTransactionsFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const PurchasePaymentTransactions: EntityType = {
  type: 'PostedTransactionsResponse',
  formTitle: 'Posted Transactions',
  instance: instanceQuery,
  fragment,
};

export default PurchasePaymentTransactions;
